const CONTACT_US_TIME_RANGE = '9:00am to 5:00pm';

export default CONTACT_US_TIME_RANGE;
